import React, { useState, useEffect } from 'react';
import { validateEmail, validatePhone } from '../../services/utils';

const TeacherForm = ({ teacher, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    Nombre: '',
    Apellido: '',
    Telefono: '',
    Email: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (teacher) {
      setFormData({
        ...teacher
      });
    }
  }, [teacher]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Validación en tiempo real
    if (name === 'Email' && value && !validateEmail(value)) {
      setErrors(prev => ({ ...prev, Email: 'Email inválido' }));
    } else if (name === 'Telefono' && value && !validatePhone(value)) {
      setErrors(prev => ({ ...prev, Telefono: 'Teléfono inválido (9 dígitos)' }));
    } else {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newErrors = {};
    
    // Validaciones requeridas
    if (!formData.Nombre.trim()) newErrors.Nombre = 'Nombre es requerido';
    if (!formData.Apellido.trim()) newErrors.Apellido = 'Apellido es requerido';
    if (!formData.Telefono.trim()) newErrors.Telefono = 'Teléfono es requerido';
    else if (!validatePhone(formData.Telefono)) newErrors.Telefono = 'Teléfono inválido';
    
    if (!formData.Email.trim()) {
      newErrors.Email = 'Email es requerido';
    } else if (!validateEmail(formData.Email)) {
      newErrors.Email = 'Email inválido';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nombre *
          </label>
          <input
            type="text"
            name="Nombre"
            value={formData.Nombre}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Nombre ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
          />
          {errors.Nombre && (
            <p className="mt-1 text-sm text-red-600">{errors.Nombre}</p>
          )}
        </div>

        {/* Apellido */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Apellido *
          </label>
          <input
            type="text"
            name="Apellido"
            value={formData.Apellido}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Apellido ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
          />
          {errors.Apellido && (
            <p className="mt-1 text-sm text-red-600">{errors.Apellido}</p>
          )}
        </div>

        {/* Telefono */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Teléfono *
          </label>
          <input
            type="tel"
            name="Telefono"
            value={formData.Telefono}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Telefono ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
          />
          {errors.Telefono && (
            <p className="mt-1 text-sm text-red-600">{errors.Telefono}</p>
          )}
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email *
          </label>
          <input
            type="email"
            name="Email"
            value={formData.Email}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Email ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
          />
          {errors.Email && (
            <p className="mt-1 text-sm text-red-600">{errors.Email}</p>
          )}
        </div>
      </div>
      {/* Botones */}
      <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          {teacher ? 'Actualizar' : 'Guardar'}
        </button>
      </div>
    </form>
  );
};

export default TeacherForm;